export default class MarginsHandler {
	init() {
		this.handleOverlapSections();
		this.handleBackgroundPadding();
		this.handleHeroMargins();

		// Re-calculate on window resize with debounce
		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this.handleOverlapSections();
				this.handleBackgroundPadding();
				this.handleHeroMargins();
			}, 1);
		});
	}

	handleOverlapSections() {
		const sections = document.querySelectorAll('[data-overlap]');

		sections.forEach((section) => {
			// Get the actual height of the overlap section
			const sectionHeight = section.offsetHeight;
			const halfHeight = sectionHeight / 2;

			// Apply negative margins (half height) to the overlap section
			section.style.marginTop = `-${halfHeight}px`;
			section.style.marginBottom = `-${halfHeight}px`;

			// Ensure z-index for proper stacking
			section.classList.add('z-20', 'relative');

			// Add padding to previous sibling (section or footer)
			const previousSibling = this.getAdjacentElement(section, 'previous');
			if (previousSibling) {
				previousSibling.style.paddingBottom = `${halfHeight}px`;
				if (previousSibling.classList.contains('mb-xl')) {
					previousSibling.classList.remove('mb-xl')
				}
			}

			// Add padding to next sibling (section or footer)
			const nextSibling = this.getAdjacentElement(section, 'next');
			if (nextSibling) {
				nextSibling.style.paddingTop = `${halfHeight}px`;
			}
		});
	}

	handleBackgroundPadding() {
		// Find all sections with bg-* class
		const sections = document.querySelectorAll('section[class*="bg-"]');

		sections.forEach((section) => {
			// Check if section has a bg-* class (background color)
			const hasBgClass = Array.from(section.classList).some(cls => cls.startsWith('bg-'));

			// Skip if no bg class or if it's bg-white or bg-black
			if (hasBgClass && !section.classList.contains('bg-white') && !section.classList.contains('bg-black')) {
				// Skip if previous sibling has data-overlap attribute
				const prevSibling = section.previousElementSibling;
				if (prevSibling && prevSibling.hasAttribute('data-overlap')) {
					return;
				}

				// Find the first child div
				const childDiv = section.querySelector(':scope > div');

				if (childDiv) {
					const classList = Array.from(childDiv.classList);

					// Check if child div has pt-* class
					const hasPaddingTop = classList.some(cls => cls.startsWith('pt-'));

					// Check if child div has pb-* class
					const hasPaddingBottom = classList.some(cls => cls.startsWith('pb-'));

					// Add pt-xl if no padding top exists
					if (!hasPaddingTop) {
						childDiv.classList.add('pt-xl');
					}

					// Add pb-xl if no padding bottom exists
					if (!hasPaddingBottom) {
						childDiv.classList.add('pb-xl');
					}
				}
			}
		});
	}

	handleHeroMargins() {
		// Find all article elements
		const articles = document.querySelectorAll('article');

		articles.forEach((article) => {
			// Get all sections within the article
			const sections = article.querySelectorAll('section');

			// Check if we have at least 2 sections
			if (sections.length >= 2) {
				const heroSection = sections[0]; // First section is the hero
				const sectionAfterHero = sections[1]; // Second section

				// Check if the section after hero has a bg-* class that isn't bg-white
				const hasBgClass = Array.from(sectionAfterHero.classList).some(cls => cls.startsWith('bg-'));
				const isNotWhiteBg = !sectionAfterHero.classList.contains('bg-white');

				if (hasBgClass && isNotWhiteBg) {
					// Remove all mb-* classes from the hero section
					const heroClasses = Array.from(heroSection.classList);
					heroClasses.forEach((className) => {
						if (className.startsWith('mb-')) {
							heroSection.classList.remove(className);
						}
					});
				}
			}
		});
	}

	getAdjacentElement(element, direction) {
		const sibling = direction === 'previous'
			? element.previousElementSibling
			: element.nextElementSibling;

		// Return if it's a section or footer element
		if (sibling && (sibling.tagName === 'SECTION' || sibling.tagName === 'FOOTER')) {
			return sibling;
		}
		return null;
	}
}
